import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { LoaderService } from '../../components/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { HttpStatusCode } from '../util/constants';
import { ConfigsLoaderService } from 'app/shared/configs-loader.service';

// const baseUrl = 'https://auditassistportal-dev.ey.com/api/'; // Dev
// const baseUrl = 'https://useqint0hkwap02.azurewebsites.net/api/'; // QA
// const baseUrl = 'https://usepint0g1wap02.azurewebsites.net/api/'; // Prod
// const baseUrl = 'https://localhost:44362/api/'; // Localhost
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public baseUrl;
  header = new HttpHeaders().append('content-type', 'application/json');
  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    private readonly configsLoaderService: ConfigsLoaderService
  ) {
    this.baseUrl = this.configsLoaderService.API_BASE_URI+'/api/';
  }

  async getDataByID(listname, id): Promise<any> {
    const promise = new Promise((resolve, reject) => {
      this.showLoader();
      const url = this.baseUrl + listname + '/' + id;
      this.http
        .get<any>(url)
        .pipe(catchError(this.errorHandler))
        .toPromise()
        .then(
          (res) => {
            this.hideLoader();
            resolve(res);
          },
          (msg) => {
            // Error
            this.toastr.error('Some error occured. Please try again later.', 'Error!');
            this.hideLoader();
            reject(msg);
          }
        );
    });
    return promise;
  }

  async getData(listname): Promise<any> {
    const promise = new Promise((resolve, reject) => {
      this.showLoader();
      const url = this.baseUrl + listname;
      this.http
        .get<any[]>(url)
        .pipe(catchError(this.errorHandler))
        .toPromise()
        .then(
          (res) => {
            this.hideLoader();
            resolve(res);
          },
          (msg) => {
            // Error
            this.toastr.error('Some error occured. Please try again later.', 'Error!');
            this.hideLoader();
            reject(msg);
          }
        );
    });
    return promise;
  }

  async postDataForSync(data: any[], listname, showLoader = true): Promise<any> {
    if (showLoader) {
      this.showLoader();
    }
    const promise = new Promise((resolve, reject) => {
      const url = this.baseUrl + listname;
      this.http
        .post<any>(url, data,{headers: this.header})
        .pipe(catchError(this.errorHandler))
        .toPromise()
        .then(
          (res) => {
            // Success
            this.hideLoader();
            resolve(res);
          },
          (msg) => {
            // Error
            this.toastr.error(msg, 'Error!');
            this.hideLoader();
            reject(msg);
          }
        );
    });
    return promise;
  }

  async postData(data: any, listname, showLoader = true): Promise<any> {
    if (showLoader) {
      this.showLoader();
    }
    const promise = new Promise((resolve, reject) => {
      const url = this.baseUrl + listname;
      this.http
        .post<any>(url, data,{headers: this.header})
        .pipe(catchError(this.errorHandler))
        .toPromise()
        .then(
          (res) => {
            // Success
            this.hideLoader();
            resolve(res);
          },
          (msg) => {
            // Error
            this.toastr.error(msg, 'Error!');
            this.hideLoader();
            reject(msg);
          }
        );
    });
    return promise;
  }

  async deleteData(id: number, listname): Promise<any> {
    this.showLoader();
    const promise = new Promise((resolve, reject) => {
      const url = this.baseUrl + listname + '/';
      this.http
        .delete(url + id)
        .pipe(catchError(this.errorHandler))
        .toPromise()
        .then(
          (res) => {
            // Success
            this.hideLoader();
            resolve(res);
          },
          (msg) => {
            // Error
            this.toastr.error('Some error occured. Please try again later.', 'Error!');
            this.hideLoader();
            reject(msg);
          }
        );
    });
    return promise;
  }

  async updateData(data: any, id: number, listname): Promise<any> {
    this.showLoader();
    const promise = new Promise((resolve, reject) => {
      const url = this.baseUrl + listname + '/';
      this.http
        .put<any>(url + id, data,{headers: this.header})
        .pipe(catchError(this.errorHandler))
        .toPromise()
        .then(
          (res) => {
            // Success
            this.hideLoader();
            resolve(res);
          },
          (msg) => {
            // Error
            this.toastr.error('Some error occured. Please try again later.', 'Error!');
            this.hideLoader();
            reject(msg);
          }
        );
    });
    return promise;
  }

  /** Error Handling method */

  errorHandler(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error.MessageMessage}`);
      if (error.status === HttpStatusCode.BAD_REQUEST) {
        return throwError(error.error.Message);
      }
    }
    // return an observable with a user-facing error message
    return throwError('Some error occured. Please try again later.');
  }

  public showLoader(): void {
    this.loaderService.show();
  }
  public hideLoader(): void {
    this.loaderService.hide();
  }
}
